/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleJournalPointResponseDto } from './equipment-schedule-journal-point-response-dto';


export interface EquipmentScheduleJournalPointResponseDtoPagedList { 
    totalCount?: number;
    items?: Array<EquipmentScheduleJournalPointResponseDto> | null;
}

